/**
 * Конфигурация Cloud Functions URLs
 */

// Определяем окружение
const isDevelopment = 
  import.meta.env.MODE === 'development' || 
  (import.meta.env.DEV && import.meta.env.MODE !== 'production');

// URLs Cloud Functions
const CLOUD_FUNCTIONS = {
  development: {
    // Yandex Cloud Functions (те же что и production)
    crdParser: {
      url: 'https://functions.yandexcloud.net/d4eieqcti6kesc41hq2j',
    },
    fileUpload: {
      url: 'https://functions.yandexcloud.net/d4e0qvh7ek7glq4bjqp0',
    },
    userSettings: {
      url: 'https://functions.yandexcloud.net/d4ejtd23jk65ib3n9t9u',
    },
    userData: {
      url: 'https://functions.yandexcloud.net/d4ejtd23jk65ib3n9t9u',
    },
  },
  production: {
    // Production Yandex Cloud Functions (прямые URLs)
    crdParser: {
      url: 'https://functions.yandexcloud.net/d4eieqcti6kesc41hq2j',
    },
    fileUpload: {
      url: 'https://functions.yandexcloud.net/d4e0qvh7ek7glq4bjqp0',
    },
    userSettings: {
      url: 'https://functions.yandexcloud.net/d4ejtd23jk65ib3n9t9u',
    },
    userData: {
      url: 'https://functions.yandexcloud.net/d4ejtd23jk65ib3n9t9u', // TODO: Update with actual user-data function URL
    },
  },
};

// Выбираем конфигурацию на основе окружения
const currentFunctions = isDevelopment 
  ? CLOUD_FUNCTIONS.development 
  : CLOUD_FUNCTIONS.production;

// Экспортируем конфигурацию
export default {
  functions: currentFunctions,
  isDevelopment,
  isProduction: !isDevelopment,
};

// Для отладки
if (isDevelopment) {
  console.log('[API Config] Cloud Functions:', currentFunctions);
}
